const multiplier = 100;
export const toPercentage = (x: number | string | undefined, defaultVal = 0) =>
    typeof x === "number" || (typeof x === "string" && !isNaN(+x)) ? Number((+x * multiplier).toFixed(2)) : defaultVal;
